import groupBy from 'lodash/groupBy';

import { CardFlat, FlatListCityGroup } from 'core/entities/flats';

export const useGroupedByCityFlats = (flats: Array<CardFlat>) => {
  const groupedByCityFlats = groupBy(flats, (flat) => flat.city.id);
  const groups: Array<FlatListCityGroup> = Object.keys(groupedByCityFlats).map((cityId) => {
    const cityFlats = groupedByCityFlats[cityId];
    return {
      key: Number(cityId),
      flatList: cityFlats,
      city: cityFlats[0].city
    };
  });

  return groups;
};

export const useBuildingTypeToText = (buildingType: string, rooms: number, short = false) => {
  if (buildingType === 'flat') {
    if (short) {
      return rooms ? `${rooms}-комн` : 'кв';
    }
    return rooms ? `${rooms}-комнатная` : 'квартира';
  } else if (buildingType === 'cottage') {
    if (short) {
      return rooms ? `${rooms}комн коттедж` : 'коттедж';
    }
    return rooms ? `${rooms}-комнатный коттедж` : 'коттедж';
  } else if (buildingType === 'room') {
    return 'комната';
  }

  return null;
};
